import { FC, useState, useCallback } from 'react'
import { UserType, SwaggerRoutes } from '../types'
import { UserCard } from './UserCard'
import { UserPermissionsModal } from './UserPermissionsModal'

interface UserCardGridProps {
  users: UserType[]
  routes: SwaggerRoutes[]
  loading?: boolean
  onSavePermissions?: (userId: number, permissions: SwaggerRoutes[]) => void
  columns?: number
  emptyMessage?: string
}

export const UserCardGrid: FC<UserCardGridProps> = ({
  users,
  routes,
  loading = false,
  onSavePermissions,
  columns = 3,
  emptyMessage = 'Nenhum usuário encontrado',
}) => {
  const [selectedUser, setSelectedUser] = useState<UserType | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleEditPermissions = useCallback((user: UserType) => {
    setSelectedUser(user)
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
    setSelectedUser(null)
  }, [])

  const handleSavePermissions = useCallback(
    (userId: number, permissions: SwaggerRoutes[]) => {
      onSavePermissions?.(userId, permissions)
      console.log(`Permissões salvas para usuário ${userId}:`, permissions)
    },
    [onSavePermissions]
  )

  if (loading) {
    return (
      <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '400px' }}>
        <div className='spinner-border' role='status'>
          <span className='visually-hidden'>Carregando...</span>
        </div>
      </div>
    )
  }

  if (!users || users.length === 0) {
    return (
      <div className='text-center py-5'>
        <i className='fas fa-users fs-1 text-muted d-block mb-3'></i>
        <p className='text-muted'>{emptyMessage}</p>
      </div>
    )
  }

  const colClass =  'col-lg-4 col-md-6'

  return (
    <>
      <div className='row g-4'>
        {users.map((user) => (
          <div key={user.id} className={colClass}>
            <UserCard
              user={user}
              onEditPermissions={handleEditPermissions}
            />
          </div>
        ))}
      </div>

      <UserPermissionsModal
        user={selectedUser}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        routes={routes}
        onSavePermissions={handleSavePermissions}
      />
    </>
  )
}
